export const appConfigMapping = {
  security: {
    securityDomains: (<any>window).appConfig.security.securityDomains,
    clientId: (<any>window).appConfig.security.clientId,
    autoConfigUrl: (<any>window).appConfig.security.autoConfigUrl
  },
  api: {
    lmsApi: (<any>window).appConfig.api.lmsApi
  },
  maintenance: {
    message: (<any>window).appConfig.maintenance.message,
    effectiveDate: (<any>window).appConfig.maintenance.effectiveDate,
    expireDate: (<any>window).appConfig.maintenance.expireDate
  },
  enableDatadogRum: (<any>window).appConfig
    ? (<any>window).appConfig.enableDatadogRum
    : undefined,
  datadog: {
    applicationId: (<any>window).appConfig?.datadog?.applicationId,
    clientToken: (<any>window).appConfig?.datadog?.clientToken,
    site: (<any>window).appConfig?.datadog?.site,
    service: (<any>window).appConfig?.datadog?.service,
    env: (<any>window).appConfig?.datadog?.env,
    version: (<any>window).appConfig?.datadog?.version,
    sessionSampleRate: (<any>window).appConfig?.datadog?.sessionSampleRate,
    sessionReplaySampleRate: (<any>window).appConfig?.datadog?.sessionReplaySampleRate,
    trackBfcacheViews: (<any>window).appConfig?.datadog?.trackBfcacheViews,
    defaultPrivacyLevel: (<any>window).appConfig?.datadog?.defaultPrivacyLevel,
    allowedTracingUrls: (<any>window).appConfig?.datadog?.allowedTracingUrls,
    forwardErrorsToLogs: (<any>window).appConfig?.datadog?.forwardErrorsToLogs,
  }
};
